import { hasValue, isString } from '@util/type';
import * as R from 'ramda';

const replaceFirst = R.replace(/^./);

const trimIfString = R.ifElse(
  isString,
  R.trim,
  R.identity
);

type Capitalize = (s: string) => string;
export const capitalize: Capitalize = replaceFirst(<any>R.toUpper);

type ToNumber = (s: string) => number | null;
export const toNumber: ToNumber = R.ifElse(
  hasValue,
  R.compose(Number, trimIfString),
  R.always(null)
);
type ToNumbers = (s: string[]) => number[];
export const toNumbers: ToNumbers = R.map(toNumber);

type SplitByComma = (s: string) => string[];
export const splitByComma: SplitByComma = R.split(',');

type ToArrayOfNumbers = (s: string) => number[];
export const toArrayOfNumbers: ToArrayOfNumbers = R.ifElse(
  R.compose(hasValue),
  R.compose(toNumbers, splitByComma),
  R.always([])
);

type ToString = (value?: any) => string;
export const toString: ToString = R.ifElse(hasValue, String, R.always(''));

type JoinByComma = (s: any[]) => string;
export const joinByComma: JoinByComma = R.join(', ');

interface Concat {
  (s1: string, s2: string): string;

  (s1: string): ((s2: string) => string);
}

export const concat: Concat = R.concat;
